var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-select',{attrs:{"size":"sm","shadow":false,"options":_vm.options},on:{"change":_vm.onChange},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})
}
var staticRenderFns = []

export { render, staticRenderFns }